







































































































































































































































































































































import { computed, defineComponent } from '@vue/composition-api'
import useTelemetrySectionUtil from '@/components/RaceVideoPage/RaceVideoDataViewPane/hook/useTelemetrySectionUtil'

/**
 * レース動画再生画面 テレメトリー オーバーテイク残時間 値パーツのコンポーネント
 */
export default defineComponent({
  name: 'TelemetryOtsParts',
  components: {},
  props: {
    /**
     * バリュー値
     */
    value: {
      type: Number,
      required: true,
      default: 0,
    },
    /**
     * オーバーテイクシステム有効フラグ
     */
    otsEnabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    /**
     * オーバーテイクシステム無効残時間
     */
    otsDisabledTime: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  setup(props) {
    const { adjustPosition } = useTelemetrySectionUtil()

    // 位置指定を整数化
    adjustPosition('.telemetry-ots-parts')

    // ゲージ横幅
    const gaugeSvgWidth = 123

    /**
     * gaugeWidth
     * ゲージの横幅を算出
     */
    const gaugeWidth = computed(() => (gaugeSvgWidth * props.value) / 200)

    /**
     * gaugePositionX
     * ゲージのX位置を算出
     */
    const gaugePositionX = computed(() => gaugeSvgWidth - (gaugeSvgWidth * props.value) / 200 + 7)

    /**
     * SVGカラー
     * 残秒数が一定以下時に赤へ変更
     */
    const fillColor = computed(() => (props.value > 20 ? '#fff' : '#ff2e00'))

    /**
     * オーバーテイクシステム無効状態判定
     */
    const otsDisabled = computed(() => props.otsDisabledTime > 0)

    return {
      gaugeWidth,
      gaugePositionX,
      fillColor,
      otsDisabled,
    }
  },
  methods: {},
})
